import $ from 'jquery';
import manageRefineMenu from '../plp/manage-refine-menu';
import setupBisAndSo from '../pdp/bis-and-so';
import wishlist from 'modules/wishlist';
import { initSidePanel } from '../../modules/init-side-panel';

window.rcProps.setupBisAndSo = setupBisAndSo;
window.initWishlist = initWishlist;

$(document).ready(function() {
    initWishlist(true);
});

function initWishlist(refineMenuRequired) {
    if (refineMenuRequired) {
        initSidePanel();
    }

    $('.js-bis-and-so-link').click(function (e) {
        e.preventDefault();
        var link = $(this).attr('href');
        $.modal({
            url: link,
            triggerOpen: true,
            type: 'full',
            onComplete : window.rcProps.setupBisAndSo
        });
    });
}



// WEBPACK FOOTER //
// ./src/scripts/entry-points/wishlist/index.js